import { DELETE_STATUS, ARCHIVE_STATUS } from '../../common/constants';
import type { Sort, PageRequest } from '../../common/types';
import type { GetPageRequest } from './types';

export const getOrderBy = (sort: Sort): string => {
	const { sortOrder, sortKey } = sort;
	if (sortOrder === 'DESC') {
		return `-${sortKey}`;
	}
	return sortKey;
};

// returns startAtIndex for paginated api basis given args
export const getStartAt = (page: number, pageLimit: number): number => {
	if (page <= 0) {
		return 0;
	}
	return (page - 1) * pageLimit;
};

export const getPageRequest: GetPageRequest = (
	currentPage,
	pageLimit,
	sort,
	status,
	filters,
): PageRequest => {
	const { query, typeKey } = filters;
	const searchKeyword = query.trim();

	// basic page request object
	const pageRequest: PageRequest = {
		startAt: getStartAt(currentPage, pageLimit),
		maxResults: pageLimit,
		expand: 'lead,url,permissions',
		orderBy: getOrderBy(sort),
	};

	// adding status filter for projects-table
	if (status === DELETE_STATUS || status === ARCHIVE_STATUS) {
		pageRequest.status = status;
	}

	// add filters query params to pageRequest
	if (searchKeyword.length) {
		pageRequest.query = searchKeyword;
	}
	if (typeKey.length) {
		pageRequest.typeKey = typeKey.join(',');
	}

	return pageRequest;
};
